import React, { useCallback, useContext } from "react"
import { Entities } from "@/constants"
import { QueryContext } from "@/contexts"
import Dialog from "@/components/blocks/Dialog"
import { getSchedule, updateSchedule } from "../configurations/domain"
import { EditScheduleForm } from "../forms"

export const EditDialog = ({ schedule, show, onHide, canManageTranscriptions, totalScheduledSessions }) => {
  const { getHookState } = useContext(QueryContext)
  const { request, loading } = getHookState(updateSchedule)

  const submit = useCallback(
    values => {
      const filteredValues = Object.fromEntries(
        Object.entries(values).filter(([key]) => !["school_id", "educatable_id"].includes(key))
      )
      request({
        entitiesIds: {
          [Entities.Schedules]: schedule.id,
        },
        data: {
          schedule: filteredValues,
        },
        onSuccess: onHide,
        next: [getSchedule],
      })
    },
    [schedule, request, onHide]
  )

  const dialogTitle = schedule
    ? `Schedule settings: ${schedule.educatable.name}, ${schedule.school.name}`
    : "Schedule settings"
  return (
    <Dialog title={dialogTitle} open={show} onClose={onHide} size="lg">
      <div className="mt-4">
        <EditScheduleForm
          onSubmit={submit}
          onCancel={onHide}
          schedules={[schedule]}
          totalScheduledSessions={totalScheduledSessions}
          loading={loading}
          canManageTranscriptions={canManageTranscriptions}
        />
      </div>
    </Dialog>
  )
}
